import script from "./InventoryLogisticsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryLogisticsLayout.vue?vue&type=script&setup=true&lang=js"

import "./InventoryLogisticsLayout.vue?vue&type=style&index=0&id=21b56b8d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b56b8d"]])

export default __exports__